import { IonCheckbox, IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import moment from "moment";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import { useHistory } from "react-router";
import Head from "../Header";
import Sidebar from "../Sidebar";
import swal from 'sweetalert';

const ManagerTimeSheetApproval: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
          history.push("/login");
        } else {
        }
      }, [token, history]);
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");

    const [modalopen, setModalopen] = useState(false);

    data.forEach((itm: any, index: any) => { itm.serial = index + 1; });

    const [Id] = useState(localStorage.getItem("SignupEmpId"));

    /*................. View & Update ................ */

    const [Id1, setId1] = useState("");

    const [name, setName] = useState("");
    const [statusList, setStatusList]: any = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [status, setStatus] = useState("");
    const [hours, setHours] = useState("");
    const [respondedBy, setRespondedBy] = useState("");
    const [description, setDescription] = useState("");
    const [requestedDate, setRequestedDate] = useState("");
    const [feedback, setFeedback] = useState("");
    const [timeloglist, setTimeloglist] = useState([]);
    const [Idlist, setIdlist]: any = useState([]);
    const [month, setMonth] = useState("");
    const [week, setWeek] = useState("");
    const [loading,setloading]=useState(false)
    // data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [status1, setStatus1] = useState("");

    const [id] = useState(localStorage.getItem("SignupEmpId"));

    useEffect(() => {
        LoadTimeSheetList();
    }, []);

    const LoadTimeSheetList = () => {
        setloading(true);
        service.ManagerGetTimesheetById(Id)
            .then((response) => {
                console.log("RESPONSE", response);
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
               
                setTimeout(() => {
                    setloading(false);
                }, 500); 
            });
    };
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "100px"
        },
        {
            name: "Employee",
            selector: (itm: any, i: any) => itm.empName,
            sortable: false,
            width: "300px"
        },
        {
            name: "Week",
            selector: (itm: any) => itm.description,
            sortable: true,
            width: "320px"
        },
        {
            name: "Weekly Effort",
            selector: (itm: any) => itm.totalhours,
            sortable: true,
            width: "120px"
        },
        {
            name: "Create On",
            sortable: true,
            selector: (item: any) => moment(item.requestedDate).format("DD-MM-YYYY"),
        },
        {
            name: "Status",
            sortable: true,
            cell: (itm: any) => (
                <>
                    <IonText className={itm.status.status === "Approved" ? "color_approve" : itm.status.status === "Open" ? "color_progress" : "color_deny"}>{itm.status.status}</IonText>
                </>
            )
        },
        {
            name: " Action",
            sortable: false,
            width: "120px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", paddingLeft: "15px" }}>
                        <IonText onClick={() => ViewTimeSheet(itm, itm.id)} style={{ color: "coral", cursor: 'pointer' }} >View</IonText>
                    </div>
                </>
            )
        }
    ];

    const ViewColumns: any = [
        {
            name: "S.No",
            // width: "100px",
            selector: (itm: any, i: any) => i + 1, // Calculate the serial number based on the index
            sortable: false,
        },
        {
            name: "Date",
            // width: "180px",
            selector: (itm: any) => moment(itm.date).format("DD-MM-YYYY"),
            sortable: true,
        },
        {
            name: "Project",
            sortable: true,
            // widtth: "150px",
            selector: (itm: any) => itm.project.projectName,
        },
        {
            name: "Activity",
            sortable: true,
            width: "300px",
            selector: (itm: any) => itm.activity,
        },
        {
            name: "Activity Description",
            sortable: true,
            width: "400px",
            cell: (itm: any) => (
                <div style={{ whiteSpace: "pre-wrap", overflow: "pre-wrap" }}>
                    {itm.workdescription}
                </div>
            ),
        },
        
        {
            name: "Effort",
            sortable: true,
            // width: "200px",
            selector: (itm: any) => `${itm.hours}:${itm.minutes}`,
        },
        // {
        //     name: "Effort",
        //     sortable: true,
        //     width: "100px",
        //     selector: (itm: any) => itm.timeLogList[0].hours + "." + itm.timeLogList[0].minutes,
        // },
    ];

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                padding: "0px",
                justifyContent: "center"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };

    const ViewTimeSheet = (itm: any, id: any) => {
        setModalopen(true);
        setId1(id);
        GetTimesheetStatus();
        service.ViewEmployeeTimeSheetById(id)
            .then((response) => {
                console.log(response.data);
                setName(response.data.Data.empName);
                setFromDate(response.data.Data.fromDate);
                setToDate(response.data.Data.requestedDate);
                setHours(response.data.Data.totalhours);
                setDescription(response.data.Data.description);
                setRequestedDate(moment(response.data.Data.requestedDate).format("DD-MM-YYYY"))
                setFeedback(response.data.Data.feedback);
                setTimeloglist(response.data.Data.timeSheetLog);
                var list = response.data.Data.timeLogs
                for (let i = 0; i < list.length; i++) {
                    Idlist.push(response.data.Data.timeLogs[i].id);
                }
                if (response.data.Data.respondedBy === null || response.data.Data.respondedBy === "") {
                    var lo: any = localStorage.getItem("EmpName")
                    setRespondedBy(lo);
                }
                else {
                    setRespondedBy(response.data.Data.respondedBy);
                }
                setMonth(response.data.Data.month);
                setWeek(response.data.Data.week);
            })
    }

    const GetTimesheetStatus = () => {
        service.TimeSheetStatusDropDown()
            .then((response) => {
                console.log(response, "Time Sheet Status");
                if (response.data.Status === "200") {
                    for (let i = 0; i < response.data.Data.length; i++) {
                        if (response.data.Data[i].status === "Approved") {
                            setStatus(response.data.Data[i].id)
                        }
                        else if (response.data.Data[i].status === "Rejected") {
                            setStatus1(response.data.Data[i].id)
                        }
                    }
                    setStatusList(response.data.Data);
                }
                else {
                    setStatusList([]);
                }
            })
    }

    const Approve = () => {
        service.ManagerTimesheetApprove(Id1, fromDate, toDate, description, hours, status, id, feedback, Idlist, month, week)
            .then((response) => {
                console.log(response, "iorh");
                if (response.data.Status === "200") {
                    swal("", "Updated Successfully", "success");
                    window.location.reload()
                }
                else {
                    swal("", "Not Updated", "error");
                }
            })
    }

    const Reject = () => {
        if (feedback === "" || feedback === null) {
            swal("", "Please Enter Feedback", "info");
        }
        else {
            service.ManagerTimesheetApprove(Id1, fromDate, toDate, description, hours, status1, id, feedback, Idlist, month, week)
                .then((response) => {
                    console.log(response, "iorh");
                    if (response.data.Status === "200") {
                        swal("", "Updated Successfully", "success");
                        window.location.reload()
                    }
                    else {
                        swal("", "Not Updated", "error");
                    }
                })
        }
    }

    const closemodal = () => {
        setModalopen(false);
        setIdlist([]);
        setId1("");
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>My Approvals</h3>
                                </div>
                            </div>
                            {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                            <div className="table-responsive" style={{ marginTop: "2%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    // selectableRows
                                    // onSelectedRowsChange={(item: any) => SelectTableRow(item)}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*............... View & Update ................ */}
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View TimeSheet</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Employee </label>
                                        <div>
                                            <IonInput value={name} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Month </label>
                                        <div>
                                            <IonInput value={month} type="month" readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Week </label>
                                        <div>
                                            <IonInput value={week} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>

                                </div>
                                
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Hours </label>
                                        <div>
                                            <IonInput value={hours} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Responded By </label>
                                        <div>
                                            <IonInput value={respondedBy} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Requested Date </label>
                                        <div>
                                            <IonInput value={requestedDate} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Description </label>
                                        <div>
                                            <IonInput value={description} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Feedback </label>
                                        <div>
                                            <IonInput value={feedback} onIonChange={(e: any) => setFeedback(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="table-responsive" style={{ marginTop: "1%" }}>
                            <label style={{ fontWeight: "bold" }}>Time Logs</label>
                            <DataTable
                                columns={ViewColumns}
                                data={timeloglist}
                                noDataComponent="Data not found !"
                                pagination
                                paginationPerPage={9}
                                paginationComponentOptions={paginationComponentOptions}
                                paginationRowsPerPageOptions={[3, 6, 9, 12]}
                                customStyles={customStyles}
                            />
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Approve()}>Approve</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Reject()}>Reject</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default ManagerTimeSheetApproval;